import { useMutation, useQuery } from "@tanstack/react-query";
import { APIErrorResponse } from "src/types/generic";
import apiClient from "../apiClient";

interface IParams {
  page?: number;
}

interface IBody {
  id?: string;
  name: string;
  phone?: string;
  email?: string;
  start_balance?: number | string;
  bank_account?: string;
  vat?: number | string;
  country_id?: string;
  city_id?: string;
  street?: string;
  building_number?: string;
  zip_code?: string;
  cib?: string;
  agreements?: number | string;
}

export const useGetClientsList = (params?: IParams) =>
  useQuery<any, APIErrorResponse, any>({
    queryKey: ["get-clients-list", params?.page ?? ""],
    queryFn: async () => {
      return apiClient.get(`/api/clients`, { params });
    },
  });

export const useGetDeletedClientsList = (params: IParams) =>
  useQuery<any, APIErrorResponse, any>({
    queryKey: ["get-deleted-clients-list", params.page],
    queryFn: async () => {
      return apiClient.get(`/api/clients/deleted-clients`, { params });
    },
  });

export const useAddClientMutation = () =>
  useMutation<void, APIErrorResponse, IBody>({
    mutationFn: async (data) => {
      return apiClient.post(`/api/clients`, data);
    },
  });

export const useUpdateClientMutation = () =>
  useMutation<void, APIErrorResponse, IBody>({
    mutationFn: async (data) => {
      const { id, ...rest } = data;
      return apiClient.put(`/api/clients/${id}`, rest);
    },
  });

export const useDeleteClientMutation = () =>
  useMutation<void, APIErrorResponse, number>({
    mutationFn: async (id) => {
      return apiClient.delete(`/api/clients/${id}`);
    },
  });

export const useRestoreClientMutation = () =>
  useMutation<void, APIErrorResponse, number>({
    mutationFn: async (id) => {
      return apiClient.post(`/api/clients/restore-client/${id}`);
    },
  });
